// import { useState } from 'react';
// import { TextField, Button, Typography, Card, Grid, Box, CircularProgress, IconButton } from '@mui/material';
// import { useTMutation } from '../../../utils/useTMutation';
// import { zodResolver } from '@hookform/resolvers/zod';
// import { Controller, useForm } from 'react-hook-form';
// import { useDispatch, useSelector } from 'react-redux';
// import { addAnotherLocationFacility, addCollegueSchema, } from '../../../hooks/validationSchema';
// import AutoCompleteAddress from '../../../components/AutoComplete/AutoComplete';
// import { clearFacilityLocationData, setFacilityLocationData, setColleagueData } from '../../../slice/facilityLocationSlice';
// import { useNavigate } from 'react-router-dom';
// import { handleAlphabeticInput } from '../../../utils/genericMethod';
// import showToast from '../../../components/Hot-Toast/showToast';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
// import { styled } from "@mui/material/styles";
// import LinearProgress from "@mui/material/LinearProgress";
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';


// const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
//     height: 10,
//     borderRadius: 5,
//     backgroundColor: theme.palette.grey[300],
//     "& .MuiLinearProgress-bar": {
//         borderRadius: 5,
//         backgroundColor: theme.palette.success.main,
//     },
// }));



// const AddLocation = () => {
//     const { userDetails } = useSelector(state => state.user);
//     const userID = userDetails?.ID;
//     const { facilityLocationData, colleagueData } = useSelector(state => state.facilityLocation);
//     const navigate = useNavigate();
//     const dispatch = useDispatch();
//     const [uiRender, setUiRender] = useState(0);
//     const [selectedCompleteAddress, setSelectedCompleteAddress] = useState('');
//     const [addressComponents, setAddressComponents] = useState({ street: '', state: '', country: '', zipcode: '', city: '', });
//     const [isSkipped, setIsSkipped] = useState(false);



//     const {
//         control,
//         register,
//         handleSubmit,
//         formState: { errors },
//         setValue,
//     } = useForm({
//         resolver: zodResolver(uiRender ? addCollegueSchema : addAnotherLocationFacility), // Dynamic resolver based on the step
//         defaultValues: {
//             ...colleagueData,
//             ...facilityLocationData,
//         },
//     });

//     const mutation = useTMutation("/facilityLocation", "post", (data) => {
//         if (data.STATUS) {
//             showToast("success", data.MESSAGE, 3000);
//             return data;
//         } else {
//             showToast("error", data.MESSAGE, 3000);
//         }
//     });
//     const submitFacilityLocation = async () => {

//         const response = await mutation.mutateAsync({ ...colleagueData, ...facilityLocationData, userID });
//         if (response.STATUS) {
//             BackToMain();
//         }
//     }
//     const onSubmitNext = async (data) => {

//         if (uiRender === 0) {
//             if (!data.streetAddress) { return; }
//             dispatch(setFacilityLocationData({
//                 facilityName: data.facilityName,
//                 streetAddress: data.streetAddress,
//                 addressComponents: data.address_components
//             }));
//             setUiRender(1);
//         } else if (uiRender === 1) {
//             setUiRender(2);
//         } else if (uiRender === 2) {
//             dispatch(setColleagueData({
//                 firstName: data.firstName,
//                 lastName: data.lastName,
//                 emailAddress: data.emailAddress
//             }));
//             setUiRender(1);
//         }
//     };

//     const handlePlaceSelected = (place) => {
//         if (place?.formatted_address && place?.address_components) {
//             const formattedAddress = place.formatted_address;
//             setSelectedCompleteAddress(formattedAddress);
//             setValue('streetAddress', formattedAddress);
//             const components = {
//                 city: '',
//                 state: '',
//                 street: '',
//                 country: '',
//                 zipcode: '',
//             };

//             place.address_components.forEach(component => {
//                 const type = component.types[0];
//                 if (type === 'route') components.street = component.long_name;
//                 if (type === 'country') components.country = component.long_name;
//                 if (type === 'postal_code') components.zipcode = component.long_name;
//                 if (type === 'locality') components.city = component.long_name;
//                 if (type === 'administrative_area_level_1') components.state = component.long_name;
//             });
//             setAddressComponents(components);
//             setValue('address_components', components);
//         }
//     };
//     const BackToMain = () => {
//         dispatch(clearFacilityLocationData())
//         navigate('/facility/profile')
//     }

//     const handleBacktoHome = () => {
//         // let route = '/facility/profile';
//         // let state = { state: {} }
//         // if (controlBy === "admin") {
//         //     state = { state: { ID: selectedTabData?.about?.ID } }
//         //     route = `/admin/facility-users/${controlAction}?${selectedTabData?.about?.USER_TYPE}=${selectedTabData?.about?.FIRST_NAME + " " + selectedTabData?.about?.LAST_NAME}`
//         // }
//         // navigate(route, state);
//         navigate("/facility/profile")
//     }





//     return (
//         <Grid container justifyContent="center" alignItems="center" height="75vh" padding={2}>
//             <Grid item xs={12} sm={8} md={6} lg={4}>

//                 <Box
//                     onClick={() => navigate("/facility/profile")}
//                     sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'flex-start', // Ensures the position remains consistent
//                         cursor: 'pointer',

//                         width: '100%', // Ensures it adapts to container width
//                         padding: '8px 16px', // Adjusts padding for consistent spacing
//                         position: "fixed",
//                         top: "70px",
//                         left: "12px"
//                     }}
//                 >
//                     <IconButton>
//                         <ChevronLeftIcon />
//                     </IconButton>
//                     <Typography
//                         variant="body1"
//                         sx={{
//                             whiteSpace: 'nowrap', // Prevents text from wrapping
//                             overflow: 'hidden', // Ensures no content overflow
//                             textOverflow: 'ellipsis', // Truncates long text with an ellipsis
//                         }}
//                     >
//                         Cancel
//                     </Typography>
//                 </Box>





//                 <Card sx={{ padding: '2rem', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>


//                     {uiRender === 2 ? (
//                         <>
//                             {/* Colleague Section */}
//                             <Typography gutterBottom sx={{ fontWeight: 600, fontSize: "24px" }}>Add Colleague</Typography>
//                             <form onSubmit={handleSubmit(onSubmitNext)}>
//                                 <TextField
//                                     label="First Name"
//                                     variant="outlined"
//                                     fullWidth
//                                     margin="normal"
//                                     onInput={handleAlphabeticInput}
//                                     {...register("firstName")}
//                                     error={!!errors.firstName}
//                                     helperText={errors.firstName?.message}
//                                 />
//                                 <TextField
//                                     label="Last Name"
//                                     variant="outlined"
//                                     fullWidth
//                                     margin="normal"
//                                     onInput={handleAlphabeticInput}
//                                     {...register("lastName")}
//                                     error={!!errors.lastName}
//                                     helperText={errors.lastName?.message}
//                                 />
//                                 <TextField
//                                     label="Email"
//                                     variant="outlined"
//                                     fullWidth
//                                     margin="normal"
//                                     {...register("emailAddress")}
//                                     error={!!errors.emailAddress}
//                                     helperText={errors.emailAddress?.message}
//                                 />
//                                 <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
//                                     <Button sx={{
//                                         background: "linear-gradient(-130deg, #71ba32, #4eb3e8)",
//                                         color: "#ffffff"
//                                     }} onClick={() => setUiRender(1)}>Back</Button>
//                                     <Button sx={{
//                                         background: "linear-gradient(-130deg, #71ba32, #4eb3e8)",
//                                     }} type="submit" variant="contained" disabled={mutation.isPending}>
//                                         {mutation.isPending ? <CircularProgress size={24} /> : "Submit"}
//                                     </Button>
//                                 </Box>
//                             </form>
//                         </>
//                     ) : uiRender === 1 ? (
//                         <>
//                             {/* Final Step */}

//                             <Box mt={-1}>
//                                 <ArrowBackIosNewIcon fontSize='small' sx={{ cursor: "pointer" }} onClick={() => setUiRender(0)} />
//                             </Box>

//                             <Typography mt={1} gutterBottom sx={{ fontWeight: 600, fontSize: "24px" }}>We’re at the finish line. </Typography>

//                             <Box>
//                                 <BorderLinearProgress variant="determinate" value={100} />
//                             </Box>


//                             {/* Display Facility Location Details */}
//                             <Box mb={2} mt={2}>
//                                 <Typography variant="h6">Facility Location Details</Typography>
//                                 <Typography variant="body1"><strong>Facility Name:</strong> {facilityLocationData.facilityName}</Typography>
//                                 <Typography variant="body1"><strong>Street Address:</strong> {facilityLocationData.streetAddress}</Typography>

//                             </Box>

//                             {/* Display Colleague Details */}
//                             <Box mb={2}>
//                                 <Typography variant="h6">Colleague Details</Typography>
//                                 <Typography variant="body1"><strong>First Name:</strong> {colleagueData.firstName}</Typography>
//                                 <Typography variant="body1"><strong>Last Name:</strong> {colleagueData.lastName}</Typography>
//                                 <Typography variant="body1"><strong>Email Address:</strong> {colleagueData.emailAddress}</Typography>
//                             </Box>

//                             {/* <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
//                                 <Button className="gradient-text" 
//                                 // onClick={() => setUiRender(0)}
                             
//                                 >Skip</Button>
                                
//                                <Button 
//                             //    className="gradient-text"
//                             className='custombuttons'
//                                 onClick={() => setUiRender(2)}>Add Colleague</Button>
// {/*                                 
//                                 <Button className='custombuttons' onClick={submitFacilityLocation} variant="contained">
//                                     Submit
//                                 </Button> */}
//                             {/* </Box>  */}
//                             <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
//                                 {!isSkipped ? (
//                                     <>
//                                         <Button className="gradient-text" onClick={() => setIsSkipped(true)}>
//                                             Skip
//                                         </Button>
//                                         <Button className="custombuttons" onClick={() => setIsSkipped(true)}>
//                                             Add Colleague
//                                         </Button>
//                                     </>
//                                 ) : (
//                                     <>
//                                         <Button className="gradient-text" onClick={() => setIsSkipped(false)}>
//                                             Back
//                                         </Button>
//                                         <Button className="custombuttons" onClick={submitFacilityLocation} variant="contained">
//                                             Submit
//                                         </Button>
//                                     </>
//                                 )}
//                             </Box>



//                         </>
//                     ) : (
//                         <>
//                             {/* First Section */}

//                             {/* <Box
//                 position="fixed"
//                 top={80}
//                 left={0}
//                 px={3}
//                 display="flex"
//                 alignItems="center"
//                 sx={{ cursor: "pointer" }}
//                 onClick={handleBacktoHome}>
//                 <ArrowBackIcon fontSize='small' />
//                 <Typography >Cancel</Typography>
//                 </Box > */}




//                             <Box mt={-1}>
//                                 <ArrowBackIosNewIcon fontSize='small' sx={{ cursor: "pointer" }} onClick={handleBacktoHome} />
//                             </Box>

//                             <Typography mt={1} gutterBottom sx={{ fontWeight: 600, fontSize: "24px" }}>

//                                 Add your Facility Location
//                             </Typography>


//                             <Box>
//                                 <BorderLinearProgress variant="determinate" value={33.3} />
//                             </Box>
//                             <form onSubmit={handleSubmit(onSubmitNext)}>
//                                 <TextField
//                                     label="Facility Name"
//                                     variant="outlined"
//                                     fullWidth
//                                     margin="normal"
//                                     {...register("facilityName")}
//                                     error={!!errors.facilityName}
//                                     helperText={errors.facilityName?.message}
//                                 />

//                                 <Controller
//                                     name="streetAddress"
//                                     control={control}
//                                     render={({ field }) => (
//                                         <AutoCompleteAddress
//                                             {...field}
//                                             onPlaceSelected={handlePlaceSelected}
//                                             error={!!errors.streetAddress}
//                                             helperText={errors.streetAddress?.message}
//                                             value={field.value}
//                                             onChange={(e) => {
//                                                 field.onChange(e.target.value);
//                                                 setSelectedCompleteAddress(e.target.value);
//                                             }}
//                                         />
//                                     )}
//                                 />
//                                 {!errors.streetAddress &&
//                                     Object.keys(errors.address_components || {}).length > 0 &&
//                                     (
//                                         <Box mt={2} color="error.main">
//                                             {Object.entries(errors.address_components).map(([key, error]) => (
//                                                 <Typography key={key} variant="body2">
//                                                     {error?.message || `Error in ${key}`}
//                                                 </Typography>
//                                             ))}
//                                         </Box>
//                                     )
//                                 }
//                                 <Box display="flex" justifyContent="space-between" alignItems="center" mt={5}>
//                                     <Button onClick={BackToMain} variant="outlined">
//                                         Cancel
//                                     </Button>
//                                     <Button onClick={handleSubmit(onSubmitNext)} className='custombuttons'>
//                                         Next
//                                     </Button>
//                                 </Box>
//                             </form>
//                         </>
//                     )}
//                 </Card>
//             </Grid>
//         </Grid>
//     );
// };

// export default AddLocation;



import { useState } from 'react';
import { TextField, Button, Typography, Card, Grid, Box, CircularProgress, IconButton } from '@mui/material';
import { useTMutation } from '../../../utils/useTMutation';
import { zodResolver } from '@hookform/resolvers/zod';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { addAnotherLocationFacility, addCollegueSchema, } from '../../../hooks/validationSchema';
import AutoCompleteAddress from '../../../components/AutoComplete/AutoComplete';
import { clearFacilityLocationData, setFacilityLocationData, setColleagueData } from '../../../slice/facilityLocationSlice';
import { useNavigate } from 'react-router-dom';
import { handleAlphabeticInput } from '../../../utils/genericMethod';
import showToast from '../../../components/Hot-Toast/showToast';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { styled } from "@mui/material/styles";
import LinearProgress from "@mui/material/LinearProgress";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';


const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    backgroundColor: theme.palette.grey[300],
    "& .MuiLinearProgress-bar": {
        borderRadius: 5,
        backgroundColor: theme.palette.success.main,
    },
}));



const AddLocation = () => {
    const { userDetails } = useSelector(state => state.user);
    const userID = userDetails?.ID;
    const { facilityLocationData, colleagueData } = useSelector(state => state.facilityLocation);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [uiRender, setUiRender] = useState(0);
    const [selectedCompleteAddress, setSelectedCompleteAddress] = useState('');
    const [addressComponents, setAddressComponents] = useState({ street: '', state: '', country: '', zipcode: '', city: '', });
    const [isSkipped, setIsSkipped] = useState(false);



    const {
        control,
        register,
        handleSubmit,
        formState: { errors },
        setValue,
    } = useForm({
        resolver: zodResolver(uiRender ? addCollegueSchema : addAnotherLocationFacility), // Dynamic resolver based on the step
        defaultValues: {
            ...colleagueData,
            ...facilityLocationData,
        },
    });

    const mutation = useTMutation("/facilityLocation", "post", (data) => {
        if (data.STATUS) {
            showToast("success", data.MESSAGE, 3000);
            return data;
        } else {
            showToast("error", data.MESSAGE, 3000);
        }
    });
    const submitFacilityLocation = async () => {

        const response = await mutation.mutateAsync({ ...colleagueData, ...facilityLocationData, userID });
        if (response.STATUS) {
            BackToMain();
        }
    }
    const onSubmitNext = async (data) => {

        if (uiRender === 0) {
            if (!data.streetAddress) { return; }
            dispatch(setFacilityLocationData({
                facilityName: data.facilityName,
                streetAddress: data.streetAddress,
                zipCode: data.zipCode, // Include zipCode in the stored data
                addressComponents: data.address_components
            }));
            setUiRender(1);
        } else if (uiRender === 1) {
            setUiRender(2);
        } else if (uiRender === 2) {
            dispatch(setColleagueData({
                firstName: data.firstName,
                lastName: data.lastName,
                emailAddress: data.emailAddress
            }));
            setUiRender(1);
        }
    };

    const handlePlaceSelected = (place) => {
        if (place?.formatted_address && place?.address_components) {
            const formattedAddress = place.formatted_address;
            setSelectedCompleteAddress(formattedAddress);
            setValue('streetAddress', formattedAddress);
            const components = {
                city: '',
                state: '',
                street: '',
                country: '',
                zipcode: '',
            };

            place.address_components.forEach(component => {
                const type = component.types[0];
                if (type === 'route') components.street = component.long_name;
                if (type === 'country') components.country = component.long_name;
                if (type === 'postal_code') components.zipcode = component.long_name;
                if (type === 'locality') components.city = component.long_name;
                if (type === 'administrative_area_level_1') components.state = component.long_name;
            });
            setAddressComponents(components);
            setValue('address_components', components);
            // Auto-populate the zip code field
            setValue('zipCode', components.zipcode);
        }
    };
    const BackToMain = () => {
        dispatch(clearFacilityLocationData())
        navigate('/facility/profile')
    }

    const handleBacktoHome = () => {
        // let route = '/facility/profile';
        // let state = { state: {} }
        // if (controlBy === "admin") {
        //     state = { state: { ID: selectedTabData?.about?.ID } }
        //     route = `/admin/facility-users/${controlAction}?${selectedTabData?.about?.USER_TYPE}=${selectedTabData?.about?.FIRST_NAME + " " + selectedTabData?.about?.LAST_NAME}`
        // }
        // navigate(route, state);
        navigate("/facility/profile")
    }





    return (
        <Grid container justifyContent="center" alignItems="center" height="75vh" padding={2}>
            <Grid item xs={12} sm={8} md={6} lg={4}>

                <Box
                    onClick={() => navigate("/facility/profile")}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start', // Ensures the position remains consistent
                        cursor: 'pointer',

                        width: '100%', // Ensures it adapts to container width
                        padding: '8px 16px', // Adjusts padding for consistent spacing
                        position: "fixed",
                        top: "70px",
                        left: "12px"
                    }}
                >
                    <IconButton>
                        <ChevronLeftIcon />
                    </IconButton>
                    <Typography
                        variant="body1"
                        sx={{
                            whiteSpace: 'nowrap', // Prevents text from wrapping
                            overflow: 'hidden', // Ensures no content overflow
                            textOverflow: 'ellipsis', // Truncates long text with an ellipsis
                        }}
                    >
                        Back
                    </Typography>
                </Box>





                <Card sx={{ padding: '2rem', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>


                    {uiRender === 2 ? (
                        <>
                            {/* Colleague Section */}
                            <Typography gutterBottom sx={{ fontWeight: 600, fontSize: "24px" }}>Add Colleague</Typography>
                            <form onSubmit={handleSubmit(onSubmitNext)}>
                                <TextField
                                    label="First Name"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    onInput={handleAlphabeticInput}
                                    {...register("firstName")}
                                    error={!!errors.firstName}
                                    helperText={errors.firstName?.message}
                                />
                                <TextField
                                    label="Last Name"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    onInput={handleAlphabeticInput}
                                    {...register("lastName")}
                                    error={!!errors.lastName}
                                    helperText={errors.lastName?.message}
                                />
                                <TextField
                                    label="Email"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    {...register("emailAddress")}
                                    error={!!errors.emailAddress}
                                    helperText={errors.emailAddress?.message}
                                />
                                <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
                                    <Button sx={{
                                        background: "linear-gradient(-130deg, #71ba32, #4eb3e8)",
                                        color: "#ffffff"
                                    }} onClick={() => setUiRender(1)}>Back</Button>
                                    <Button sx={{
                                        background: "linear-gradient(-130deg, #71ba32, #4eb3e8)",
                                    }} type="submit" variant="contained" disabled={mutation.isPending}>
                                        {mutation.isPending ? <CircularProgress size={24} /> : "Submit"}
                                    </Button>
                                </Box>
                            </form>
                        </>
                    ) : uiRender === 1 ? (
                        <>
                            {/* Final Step */}

                            <Box mt={-1}>
                                <ArrowBackIosNewIcon fontSize='small' sx={{ cursor: "pointer" }} onClick={() => setUiRender(0)} />
                            </Box>

                            <Typography mt={1} gutterBottom sx={{ fontWeight: 600, fontSize: "24px" }}>We're at the finish line. </Typography>

                            <Box>
                                <BorderLinearProgress variant="determinate" value={100} />
                            </Box>


                            {/* Display Facility Location Details */}
                            <Box mb={2} mt={2}>
                                <Typography variant="h6">Facility Location Details</Typography>
                                <Typography variant="body1"><strong>Facility Name:</strong> {facilityLocationData.facilityName}</Typography>
                                <Typography variant="body1"><strong>Street Address:</strong> {facilityLocationData.streetAddress}</Typography>
                                <Typography variant="body1"><strong>Zip Code:</strong> {facilityLocationData.zipCode}</Typography>

                            </Box>

                            {/* Display Colleague Details */}
                            <Box mb={2}>
                                <Typography variant="h6">Colleague Details</Typography>
                                <Typography variant="body1"><strong>First Name:</strong> {colleagueData.firstName}</Typography>
                                <Typography variant="body1"><strong>Last Name:</strong> {colleagueData.lastName}</Typography>
                                <Typography variant="body1"><strong>Email Address:</strong> {colleagueData.emailAddress}</Typography>
                            </Box>

                            {/* <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
                                <Button className="gradient-text" 
                                // onClick={() => setUiRender(0)}
                             
                                >Skip</Button>
                                
                               <Button 
                            //    className="gradient-text"
                            className='custombuttons'
                                onClick={() => setUiRender(2)}>Add Colleague</Button>
{/*                                 
                                <Button className='custombuttons' onClick={submitFacilityLocation} variant="contained">
                                    Submit
                                </Button> */}
                            {/* </Box>  */}
                            <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
                                 <Button className="custombuttons" onClick={() => setUiRender(2)}>
                                            Add Colleague
                                        </Button>
                                        <Button className="custombuttons" onClick={submitFacilityLocation} variant="contained">
                                            Submit
                                        </Button>
                                        
                                {/* {!isSkipped ? (
                                    <>
                                        <Button className="gradient-text" onClick={() => setIsSkipped(true)}>
                                            Skip
                                        </Button>
                                        <Button className="custombuttons" onClick={() => setUiRender(2)}>
                                            Add Colleague
                                        </Button>
                                    </>
                                ) : (
                                    <>
                                        <Button className="gradient-text" onClick={() => setIsSkipped(false)}>
                                            Back
                                        </Button>
                                        <Button className="custombuttons" onClick={submitFacilityLocation} variant="contained">
                                            Submit
                                        </Button>
                                    </>
                                )} */}
                            </Box>



                        </>
                    ) : (
                        <>
                            {/* First Section */}

                            {/* <Box
                position="fixed"
                top={80}
                left={0}
                px={3}
                display="flex"
                alignItems="center"
                sx={{ cursor: "pointer" }}
                onClick={handleBacktoHome}>
                <ArrowBackIcon fontSize='small' />
                <Typography >Cancel</Typography>
                </Box > */}




                            {/* <Box mt={-1}>
                                <ArrowBackIosNewIcon fontSize='small' sx={{ cursor: "pointer" }} onClick={handleBacktoHome} />
                            </Box> */}

                            <Typography mt={1} gutterBottom sx={{ fontWeight: 600, fontSize: "24px" }}>

                                Add your Facility Location
                            </Typography>


                            <Box>
                                <BorderLinearProgress variant="determinate" value={33.3} />
                            </Box>
                            <form onSubmit={handleSubmit(onSubmitNext)}>
                                <Box sx={{ mb: 1 }}>
                                <TextField
                                    label="Facility Name"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    {...register("facilityName")}
                                    error={!!errors.facilityName}
                                    helperText={errors.facilityName?.message}
                                />
</Box>
<Box sx={{ mb: 2.5 }}>
                                <Controller
                                    name="streetAddress"
                                    control={control}
                                    render={({ field }) => (
                                        <AutoCompleteAddress
                                            {...field}
                                            onPlaceSelected={handlePlaceSelected}
                                            error={!!errors.streetAddress}
                                            helperText={errors.streetAddress?.message}
                                            value={field.value}
                                            onChange={(e) => {
                                                field.onChange(e.target.value);
                                                setSelectedCompleteAddress(e.target.value);
                                            }}
                                        />
                                    )}
                                />  
</Box>
                                {/* Add Zip Code Field */}
                                {/* <TextField
                                    label="Zip Code"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    {...register("zipCode")}
                                    error={!!errors.zipCode}    
                                    helperText={errors.zipCode?.message}
                                    placeholder="Enter zip code"
                                /> */}
<Controller
  name="zipCode"
  control={control}
  defaultValue=""
  render={({ field }) => (
    <TextField
      {...field}
      value={field.value ?? ''}
      label="Zip Code"
      variant="outlined"
      fullWidth
      margin="normal"
      error={!!errors.zipCode}
      helperText={errors.zipCode?.message}
    />
  )}
/>

                                {!errors.streetAddress &&
                                    Object.keys(errors.address_components || {}).length > 0 &&
                                    (
                                        <Box mt={2} color="error.main">
                                            {Object.entries(errors.address_components).map(([key, error]) => (
                                                <Typography key={key} variant="body2">
                                                    {error?.message || `Error in ${key}`}
                                                </Typography>
                                            ))}
                                        </Box>
                                    )
                                }
                                <Box display="flex" justifyContent="flex-end" alignItems="center" mt={2} sx={{ width: "100%" }}>
                                    {/* <Button onClick={BackToMain} variant="outlined">
                                        Cancel
                                    </Button> */}
                                    <Button onClick={handleSubmit(onSubmitNext)} className='custombuttons'>
                                        Next
                                    </Button>
                                </Box>
                            </form>
                        </>
                    )}
                </Card>
            </Grid>
        </Grid>
    );
};

export default AddLocation;